define( [
  "globals",
  "base-view-model",
  "jquery",
  "knockout",
  "underscore",
  "postal",
  "pricing-support",
  "local-storage",
  "js-cookie",
  "knockout-postbox"],
function ( globals, baseViewModel, $, ko, _, postal, PricingSupport, LocalStorage, Cookies ) {
    var productPageChannel = postal.channel( "productpage" );

    var EstimateProductPricePostMeasureViewModel = function ( parentModel, sizeOptions ) {
        
        var self = this;
        
        ko.utils.extend( self, baseViewModel );
       
        self.defaultPrice = globals.price;
        self.productId = globals.productId;
        self.widthOption = globals.models.widthOption;
        self.heightOption = globals.models.heightOption;
        self.sampleOptions = globals.models.sampleOptions;
        self.oldPricingContext = undefined;

        self.defaults = {
            minWidth: 7,
            maxWidth: 156,
            minHeight: 10,
            maxHeight: 160
        };


        //at this time, we should always have cookie value
        var postMeasureCookie = JSON.parse( Cookies.get( 'postMeasureOptions' ) );
        var localPersistance = new LocalStorage();

        var widthStorage = {
            LocalStoragePersister: {},
            minDimension: self.defaults.minWidth,
            maxDimension: self.defaults.maxWidth,
            serializableValue: postMeasureCookie.Width,
            getDimensionsEighths: [{ name: "0/0", value: 0 }, { name: "1/8", value: 1 }, { name: "1/4", value: 2 }, { name: "3/8", value: 3 }, { name: "1/2", value: 4 }, { name: "5/8", value: 5 }, { name: "3/4", value: 6 }, { name: "7/8", value: 7 }]
        };
        var heightStorage = {
            LocalStoragePersister: {},
            minDimension: self.defaults.minHeight,
            maxDimension: self.defaults.maxHeight,
            serializableValue: postMeasureCookie.Height,
            getDimensionsEighths: [{ name: "0/0", value: 0 }, { name: "1/8", value: 1 }, { name: "1/4", value: 2 }, { name: "3/8", value: 3 }, { name: "1/2", value: 4 }, { name: "5/8", value: 5 }, { name: "3/4", value: 6 }, { name: "7/8", value: 7 }]
        };
        localPersistance.persist( "SELECTED_WIDTH_STORAGE_KEY", widthStorage );
        localPersistance.persist( "SELECTED_HEIGHT_STORAGE_KEY", heightStorage );
        Cookies.set( "widthz", postMeasureCookie.Width );
        Cookies.set( "hghtz", postMeasureCookie.Height );



        self.sizeOptions = $.extend( {}, self.defaults, sizeOptions );
        self.widthDimension = new PricingSupport.WidthDimension( self.sizeOptions.minWidth, self.sizeOptions.maxWidth );
        self.heightDimension = new PricingSupport.HeightDimension( self.sizeOptions.minHeight, self.sizeOptions.maxHeight );
        if (globals.productPrice.Price < 0) {
            self.price = ko.observable( "N/A" );
        } else {
            self.price = ko.observable( globals.productPrice.Price ).publishOn( "colorSelectorPrice" );
        }
        
        self.allNA = ko.computed( function () {
            return self.price() === "N/A";
        } );
        
        self.widthWhole = ko.observable( self.widthDimension.dimension.valueWhole() );
        self.heightWhole = ko.observable( self.heightDimension.dimension.valueWhole() );
        self.currentChoiceIds = ko.observableArray();
        self.dimensionsAdjustedByServer = ko.observable( globals.dimensionsAdjusted );

        self.widthWhole.subscribe( function ( newValue ) {
            self.widthDimension.dimension.valueWhole( newValue );
        } );
        self.heightWhole.subscribe( function ( newValue ) {
            self.heightDimension.dimension.valueWhole( newValue );
        } );
        self.isLoadingPrices = ko.observable( false );
        productPageChannel.subscribe( "updatePrice", function ( data ) {

            self.updatePrice();
        } );

        self.updatePrice = function ( data, e, callback ) {
            var params = buildPricingContext();
            if ( SamePricingContext( params ) ) {
                return;
            }
           
            self.oldPricingContext = params;

            $.ajax( {
                url: globals.paths.loadExactSiteProductPricing,
                type: "GET",
                contentType: "application/json; charset=utf-8",
                data: {
                    context: JSON.stringify( params )
                }
            } ).done( function ( data, status, xhr ) {
                if ( data.ForCurrentContext !== null ) {
                    if ( data.ForCurrentContext === "0" ) {
                        self.price( "N/A" );
                    } else {
                       self.price( data.ForCurrentContext.toFixed( 2 ) );
                    }
                    xhr.status = "success";
                } else {
                    self.price( "N/A" );
                    xhr.status = "failure";
                }

            } ).always( function () {
                if ( $.isFunction( callback ) ) {
                    callback();
                }
            } ).fail( function () {
                self.price( "N/A" );
            } );
        };
        var buildPricingContext = function () {
            var localPersistance = new LocalStorage();

            var savedState = localPersistance.getFromLocalStorage( "option-state-" + self.productId );
            if ( savedState ) {
                var selectedChoices = JSON.parse( savedState );
                var selectedChoiceIds = [];
                _.each( selectedChoices, function ( sc ) {
                    // Add to the collection only the sampleable choices
                    if ( sc.id !== self.widthOption.ChoiceId && sc.id !== self.heightOption.ChoiceId ) {
                        selectedChoiceIds.push( sc.id );
                    }
                } );
            }

            var params = {
                "ProductId": self.productId,
                "Choices": [],
                "ForContextOnly": true
            };

            // Width
            if ( self.widthOption !== null ) {
                params.Choices.push( {
                    ChoiceId: self.widthOption.ChoiceId,
                    OptionId: self.widthOption.OptionId,
                    OptionType: "width",
                    ChoiceValue: postMeasureCookie.Width,
                    ChoiceDataType: "DimensionInchesEighth"
                } );
            }

            // Height
            if ( self.heightOption !== null ) {
                params.Choices.push( {
                    ChoiceId: self.heightOption.ChoiceId,
                    OptionId: self.heightOption.OptionId,
                    OptionType: "height",
                    ChoiceValue: postMeasureCookie.Height,
                    ChoiceDataType: "DimensionInchesEighth"
                } );
            }

            // Samples (mostly colors)
            if ( selectedChoiceIds ) {
                _.each( self.sampleOptions.Options, function ( sampleOption ) {
                    var optionType = sampleOption.Type ? sampleOption.Type.replace( " ", "" ).toLowerCase() : "";
                    _.each( sampleOption.Groups, function ( group ) {
                        _.each( group.Choices, function ( choice ) {
                            if ( _.contains( selectedChoiceIds, choice.ChoiceId ) ) {
                                params.Choices.push( {
                                    ChoiceId: choice.ChoiceId,
                                    OptionId: sampleOption.OptionId,
                                    OptionType: optionType,
                                    ChoiceValue: true,
                                    ChoiceDataType: "List"
                                } );
                                var index = selectedChoiceIds.indexOf( choice.ChoiceId );
                                if ( index > -1 ) selectedChoiceIds.splice( index, 1 );
                            }

                            if ( !selectedChoiceIds.length ) {
                                return params;
                            }
                        } );
                    } );
                } );
            }
            return params;
        };

        var getSampleOptionIds = function () {

            // Samples (mostly colors)
            var params = [];
            _.each( self.sampleOptions, function ( sampleOption ) {
                params.push( sampleOption.OptionId );
            } );

            return params;
        };

        var SamePricingContext = function ( newPricingContext ) {
            if ( self.oldPricingContext && newPricingContext ) {
                if ( self.oldPricingContext.ProductId === newPricingContext.ProductId &&
                  self.oldPricingContext.ForContextOnly === newPricingContext.ForContextOnly &&
                  self.oldPricingContext.Choices.length === newPricingContext.Choices.length ) {
                    for ( var i = 0, j = newPricingContext.Choices.length; i < j; i++ ) {
                        var newChoice = newPricingContext.Choices[i];
                        var oldChoice = self.oldPricingContext.Choices[i];
                        if ( newChoice.ChoiceId !== oldChoice.ChoiceId ||
                            newChoice.OptionId !== oldChoice.OptionId ||
                            newChoice.OptionType !== oldChoice.OptionType ||
                            newChoice.ChoiceValue !== oldChoice.ChoiceValue ) {
                            return false;
                        }
                    }
                    return true;
                }
            }
            return false;
        };
        self.publishDimensionsChangedEvent = function () {
            postal.publish( {
                topic: "dimensions.changed",
                data: {
                    pricingContext: buildPricingContext(),
                    optionIds: getSampleOptionIds(),
                    productId: self.productId,
                    width: self.widthDimension,
                    height: self.heightDimension
                }
            } );
        };

        
    };

    return EstimateProductPricePostMeasureViewModel;

} );
